export const APPLICATION_BASE_PATH = 'app';
export const CURRENT_ENV = 'test';
export const APP_TITLE = 'Clinic';

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.sssZ';

export const bankIdBase6Image =
  'data:image/svg+xml;base64,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';

export const CHAT_POLL_RATE_IN_MS = 5000;
export const CHAT_THUMBNAIL_WIDTH = 150;
export const DEFAULT_CHAT_WIDTH = 0.31;
export const IMAGE_LIST_THUMBNAIL_WIDTH = 200;
export const FREE_TEXT_TEMPLATE_TAG = '%{freetext}';
export const FREE_TEXT_TEMPLATE_TAG_REPLACEMENT = 'FRITEXT';

export const ACCEPTABLE_FILE_TYPES = ['.pdf'];

export const LOGIN_AUTHORITY = 'loginClinic';

export const API_ERROR_CODES = {
  1: 'server_error.db_access_error',
  2: 'server_error.internal',
  3: 'server_error.unknown_user',
  4: 'server_error.insufficient_privileges',
  5: 'server_error.authentication_error',
  6: 'server_error.user_canceled_login',
  7: 'server_error.login_already_in_process',
  8: 'server_error.external_service_timeout',
  9: 'server_error.not_implemented',
  10: 'server_error.invalid_data_posted',
  11: 'server_error.missing_data',
  12: 'server_error.id_already_exists'
};

export const HTTP_STATUS_CODES = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  CONFLICT: 409
};

export const NATURAL_REMEDIES_ID = 65;
export const DIETARY_SUPPLEMENTS_ID = 67;
export const HEIGHT_ID = 125;
export const WEIGHT_ID = 124;
export const WAIST_SIZE_ID = 127;
export const PERSONAL_GOAL_ID = 14;
export const ALLERGY_QUESTION_ID = 71;
export const OVERSENSITIVITY_QUESTION_ID = 69;
export const MEDICATION_QUESTION_ID = 152;
export const ALLERGY_DSS_ITEM_ID = 20;
export const MEDICATION_CHANGE_ITEM_ID = 14;
export const MEDICATION_CHANGE_REASON_ITEM_ID = 15;
export const OCCUPATION_DSS_ITEM_ID = 5;
export const HEREDITY_DSS_ITEM_ID = 8;
export const PREVIOUS_DISEASE_DSS_ITEM_ID = 17;
export const CURRENT_DISEASE_DSS_ITEM_ID = 18;

export const BMI_WARNING_THRESHOLD = 25;

export const MEASUREMENT_COLOR_MORNING = 'rgb(234,188,12)';
export const MEASUREMENT_COLOR_DAY = 'rgb(54,135,105)';
export const MEASUREMENT_COLOR_EVENING = 'rgb(114,5,58)';
export const MEASUREMENT_COLOR_NIGHT = '#000000';

export const DIASTOLIC_MIN_VALUE = 70;
export const DIASTOLIC_MAX_VALUE = 100;
export const SYSTOLIC_MIN_VALUE = 120;
export const SYSTOLIC_MAX_VALUE = 160;
export const GENERIC_SYSTOLIC_GOAL = 135;
export const GENERIC_DIASTOLIC_GOAL = 85;

export const ENCIA_REGIONS = [
  'e7986b33-bdcd-11e9-8508-0271a0fb1e5a',
  'f891423a-b2d3-4799-b989-c94ed5db00c1',
  '75e5afcd-c607-4600-a779-1ee40004d306',
  '62603cca-82af-4087-985e-0b419d0032e8',
  '7900f3a3-4951-4107-a570-1bf24eed6ccb',
  'ee5cc8e8-2427-4f04-a827-c59b502382ff',
  '54b06a30-c483-449b-b8aa-b9fc0ad9962c',
  'b6bb44cf-cc01-45ff-a841-f68a6a8de344',
  '7eb6a4c0-de9a-4713-83ac-71c3a2fbbcac'
];

export const UNILABS_REGIONS = [
  'de3dda05-23a5-11e9-937f-342eb68fac74',
  'f5913774-a8b0-41a3-840c-2adf6b936dd5',
  '612347fe-114a-4159-adb0-4acd52aa5fb3',
  '9084727a-7cc9-46ae-b55c-e8d21542fa6a',
  'd0309328-3436-49bf-b57c-7542d3475642'
];

export const REGION_STOCKHOLM = 'ce2bd362-23a5-11e9-937f-342eb68fac74';
export const REGION_SKANE = '05d07812-7cc0-11e9-9348-342eb68fac74';
export const REGION_JONKOPING = '8358450a-0edb-4070-9044-b75dc9942a15';
export const REGION_LINKOPING = '0132dc54-b979-44f8-a67e-adef1604fd61';
export const REGION_HUDIKSVALL = 'cbe9de87-a36e-43f6-8139-da22c6db2302';
export const REGION_OSTERSUND = 'f0238dab-2bfc-4103-b9ba-cdda77d0b094';
export const REGION_KUNGSBACKA = 'b08e6491-9a9c-49f0-a174-76f089faf402';
export const REGION_RATTVIK = '9d761812-9128-4ebb-8b6e-10160607ab3f';
export const REGION_VAXJO = 'b1838440-2241-40b8-8005-8848a3b0bf5a';
export const REGION_UMEA = '210634de-19a4-46ce-807b-8ecfd19126bf';
export const REGION_SE = '00000000-0000-0000-0000-000000000001';
export const REGION_KIRUNA = '8d01c52f-073c-448f-b761-b0bfd466ce79';

const enciaMap = Object.fromEntries(ENCIA_REGIONS.map((id) => [id, 'encia']));
const unilabsMap = Object.fromEntries(UNILABS_REGIONS.map((id) => [id, 'unilabs']));

export const REGION_MAPPING = {
  ...enciaMap,
  ...unilabsMap,
  [REGION_STOCKHOLM]: 'stockholm',
  [REGION_SKANE]: 'skane',
  [REGION_JONKOPING]: 'jonkoping',
  [REGION_LINKOPING]: 'linkoping',
  [REGION_HUDIKSVALL]: 'hudiksvall',
  [REGION_OSTERSUND]: 'ostersund',
  [REGION_KUNGSBACKA]: 'kungsbacka',
  [REGION_RATTVIK]: 'rattvik',
  [REGION_VAXJO]: 'vaxjo',
  [REGION_UMEA]: 'umea',
  [REGION_SE]: 'sweden',
  [REGION_KIRUNA]: 'kiruna'
};

export const NEW_MEMBERS_COLLAPSE_THRESHOLD = 3;

export const ANDROID = 'ANDROID';
export const IOS = 'IOS';
export const ANDROID_VERSION_WITH_TREATMENT_GOALS = '1.0.7';
export const ANDROID_VERSION_WITH_HARD_CODED_DOCTOR_TITLE = '1.1.7';
export const IOS_VERSION_WITH_HARD_CODED_DOCTOR_TITLE = '1.1.4';

export const SOURCES_EXCLUDED_FROM_CREATING_FINAL_NOTES = [];

export const DEFAULT_NUM_LAB_RESULT_COLUMNS = 2;
export const NUM_LAB_RESULT_COLUMNS_WITHOUT_EVALUATION = 5;
export const DEFAULT_LAB_RESULT_COLUMN_WIDTH = 280;
export const LAB_RESULT_COLUMN_WIDTH_WITHOUT_EVALUATION = 100;

export const SUPERSCRIPTED_GOAL_VALUES = ['PKOLN', 'PLDLDN'];

export const FEMALE_PLACEHOLDER_AUTHOR_ICON =
  'iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAIAAABKoV4MAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAmrSURBVFhHnVgLjFTVGf7POfc1s7OzuywsLHRBEIKpGpZaKYUUayPSbQPaFlOaloeRBgtFDLY1RBpUbKPRIqDUSNOkatM0NRUIaLW0pJiKsWgDJQYjhQZkF/bBY3Z3Hvfe8+h3ZsaFhZll2y93b+6cc8//n//1/ecuM8bQNaGIhCYKiRJ4BAzFDGPEyDhGEsMPR+IZE8SLbwwPw1BvSDIoc+0GqPPpB29vkp9oIxlToS8jU9+TaXzsV2+QmFJgFFA/Uaq0bjgYlvWxIVed+sW908Y151ivn3GTsNpwWRO6wijF+w0vGD95/a2rZ33nyfKa4WEY6q3R3X94eFIhP4wwES3ZdJY8l6RPTnlkCAxDfdT74kNjAsNZcSPXRE7m79+WUYKLYUTh2nnyxMqpKYPYy+LL175qqWnb2noRDSsDsKASDJJdRjGRPN7s9EXaNayCk4ySkcwZiiiK7P4YkoRLN9PIGp5fWYeUkTZthkIV9Qx+djxOm9fNQ/CLqCAnjsLRTa1L1z4fiiQ3tjYdzZlxNKmA58k9IrQLC8pvV0IV9cTthOmpKXRqxRgTtr4HZ4kQwqkZM3/RGiMbv//Q031ROhezWIMbSErped6vf9IGK8AIQ6Cq84myf9+1rXAOtpevARhy4Gpt2LK1m/oNTAbhjFz2g5+3TGntV4VSqQCF0x1kPsLLpZ8VUc35dtdv7/y9U8O0VaUVGamUskEwmmlOauyE6UYFqeQoxlNG8KB2xJ1fXV474roBmaObajcs/9rQ1VLN+fAg89jZWMewUhuOe/FlLoTr8H7tjp4z73ta+EY4JBzcsUvuppd+d4NRno234VklW2pzgjJlgZVQXb3iLmWsahhuL1YKAedOwkkuvn+dm25igjPuEHcY9xjq3FFg/ZtunA42gWTFKGkukKXhqqis3oY+/35BJm9uTud0KGM3Uo5wkt/8xopYuiNaZpDTRNJFTpJIEk+Q4JoLzZD19NkZdzCNqbyrUXmjqP1USWZFVGY9DD163/R0eGJqY/yVRes8v9ahUOm8ELUvv7R9yfJHyK0lPzCez3gN+p3ReSYjivt03M9N4ZXnfgT/a67cOHm0ULPxN6fLcq9CZesR5+7OdqYk2Of8xT4Jx5IWvA7Jt3jxCuIRiRwS0CA+QiDmNgTl5BCkDBm8byVz3j9yZG9JZkVUib2hVJAjJgqat7d/EnhpIhdMyBnC7IDa8BN/HNthHPQOjrKLjLGNn/tBXYPWkhlXk3DjppLIiqiinihwjRBeNuSZTMaSUJGHroKGsXD9QK1fDowrTkL+P5kPVyukeV463d3diK6O0QDKgJUl2EpAgGRM4AXoQxJgUMpCoeA48AeImNe4OTtYBYPU27eM7TPEckwmc1JmpL548aI9U7moZmgAi0qjUdYK/QYURCriGkwXg5ZIaY5KDbMmytsEYGB7BAEFmP1UuJVxOQapR7nmGJqEWXbbpCiKZaxhWEdHR3n6U3DwHsIML8BoDdNjUniwyuwhKLASsI3y20VUc8Bg57M4Sb0PfPuWcY2SMw9LIAatBTN8IPZWsYLRDHaT9YRR2EFk1eOupInz8NBANpQUW4aoBCtU5rHrkEz7fW0ta+dPrs2fga+RNbhi5I5N7JiZJHgUV9FySLRNgFQMXzMZ2vCDGtGUtTzX3aE4pDnWmcYrMouLXmH1X7UHHkWRkz/29VsaHr5nWoobsFtOI/joMhq5pxBeY/IXekhcWopjrs24ogPsQ8n/1npoVf8+/mHxLey1uMQI8PEl5w0GR2MO66fuOXD2qVcOb9mxf0zzeGRNPgwN0kgLg8WM7/3Ln9B/mVNu+dymXtHVVmtksxWX7fS45499dJiDIMC4eJnhFBTACSVlV8O6xkC0yq64+8ss7NGyUJeu0TKCy1FuoLvAYQnfv7n1prY776K4KBSHfOGRExAPwPalCJLOxdnMiy9sqg1yRiMtNNogvgWU8u99AY2nivX4YyZBvKmjp5+z2PPg1ByssX2dDO5hrLJR+O57B99643VywHqWgizTSNSn0jL34Qf7+85+/O6bf/zzrt/yuBtHRGwR82hHEB0lULGVdQOlCXvffeCYaLyB/AkRpUMksK2sEnU7qEDYfPhf/zx98jjYluHMXax+qWBo7sYvtv7n2AcH33v73Jn2+kTSdmHE2oFum/8mMaeoojKs83GoRa+OQSNM++SR6V3xrc8lowslqsUxj6Gd4kGFjz/2OIZOHDs2ceL1WBuHYVdX12cmTy5+BwUUnd+6ZUMicNF77VpC+qjFT/RQfV1Z21WwdkM37q5whHTvWTBtadt41puJmZA4x0imCJ0Dvigkkyl0XZDYpElToBtR8BpHjRk7lkJkIkrvXBz6GGPKQ8lEPNT94akLaV1TVTcwKCqOZ17d9U7KHUV0gcJIqb7QIdfT53NB3m/9uAsdLgaP2+xDQeHY13dei8AEDZSsE8gTEXTGEzImcngQZAOW9h95qYO5w264tm+I1JZXDycm3SXdpF/Tcvxc+tnXeljLvFP58bv3dwnPMuAA7PnbS7GGZpkN8Qn28p4Dh+LWf/Te/eSe6Kev5ZY8egj+YxrNuipKFHYJUko0q9mzZ588eXLGjBlhGPq+X5o68NbOswefMXlUZPnLQTLp+qNB+HHYY5z+sbf+7LaFC01Y+hcAua6L5bt27dq7d++cOXNsCfqIziCDB6kHvc+cOTOVSuHVZDKJreCh2DotmMz9buOCtJDFQ4UFup6hAKs4hecj9uAz73T2ZR17NLKAJkiI4xiEDyFo3EeOHEEvvpz/y+o3b968Y8cOEC1IEPfS3BWQOt63dbWrTiDLy0MWdjnYvS+4Yf4PN+MjS/Gyb64AtGIrPT09R48eLQ+VYp/NZnfu3Ik52JrPg3ArI5sPuwrg10Heg1irndF1rQuigs7HmfLbVwF2Q35DQwM8gUZTXoyJWbNmjRgxAvsqDVVDNowmBl1vbv/xgPMHoMj5wtJnyRl1RZuviCAI2tra1q9fD3+wVatW7du3rzwzJPAtcebo4fPvbwURl4eKQPi0N3LqwqdqbC8KBhJzAFdkN3IC8S2FQLS3t2MaOXJNRLFKp8XKRV8a+DcHzh046eooHvf5NU5tHY5HsVTItvKCKkCUcT9z5szcuXNZS0sLfpfEDQ2cG/Gxcfz1jV7x7AZAvcTBm/k109fUNTdfYeXQyOVyOEOzxsbGaql+BVgx6U7/7ZeBKn83IeFB6xHVj5m3jsthCRkAQoBsY4lE4vJCHALwuTH+7uceuL21vjSCXsRN/NdDnXes3p5Ec/hfAKVa6/8CKF64C9f+Y4cAAAAASUVORK5CYII=';
export const MALE_PLACEHOLDER_AUTHOR_ICON =
  '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';

export const RISK_FACTOR_LOW_PHYSICAL_ACTIVITY_ID = 8;
export const RISK_FACTOR_WEIGHT_ID = 9;

export const MEMBERS_PER_PAGE = 20;

export const MAX_NOTE_LENGTH = 4000;

export const NULL_GUID = '00000000-0000-0000-0000-000000000000';

export const MAINTENANCE_STORAGE_KEY = 'maintenanceStartsAt';
export const INBOX_VISITED_PATIENTS_KEY = 'visitedPatients';
export const MAIN_MENU_COLLAPSE_STATE_KEY = 'mainMenuCollapsedv2';
export const HEALTH_PING_SUCCESS_THRESHOLD = 2;

export const INBOX_PRIORITY_LIMIT = 8;

export const AUTHORITY = {
  CAREGIVER: 'caregiver',
  HEALTH_SCIENTIST: 'healthscientist',
  NURSE: 'nurse',
  VIEW_PATIENTS: 'viewPatients',
  HANDLE_AUSCULTATION: 'handleAuscultation',
  MEDICAL_MANAGEMENT: 'medicalManagement',
  HANDLE_NEXT_GEN_PATIENTS: 'handleNextGenPatients',
  TECH_PRODUCT: 'techProduct',
  COPS: 'cops',
  VIEW_ALL_ERRANDS_FOR_ROLE: 'viewAllErrandsForRole'
};

export const CAREGIVER_ROLE = {
  DOCTOR: 'doctor',
  NURSE: 'nurse'
};

export const SERVICE_STATUS = {
  DOCTOR: 'doctor',
  NURSE: 'nurse',
  HIDDEN: 'hidden',
  BLOCKED: 'blocked',
  DEACTIVATING: 'deactivating'
};

export const PATIENT_FEE_EXEMPTED_SOURCES = ['EuroAccident'];

export const PAL_EVENTS = ['reminder', 'threeMonthCheckup', 'yearlyCheckup', 'checkup'];
export const PAS_EVENTS = ['nurseReminder', 'nurseCheckup'];

export const MANDATORY_QUESTIONS_ONBOARDING_CHAPTER_ID = 1005;
export const MANDATORY_QUESTIONS_BEFORE_CHECKUP_CHAPTER_ID = 1007;

export const LAST_N_MEASUREMENTS_LIMIT = 5;

export const COMMUNICATION_ROW_LIMIT = 10;
export const COMMUNICATION_ROWS_PER_PAGE = 10;

export const NURSE_CHECKUP_TYPES = ['nurseNewMember', 'nurseTwoWeek', 'nurseSixMonth', 'nurseYearly', 'nurseExtra'];
export const DOCTOR_CHECKUP_TYPES = [
  'newMemberCheckup',
  'sixWeekCheckup',
  'threeMonthCheckup',
  'yearlyCheckup',
  'extraCheckup',
  'diagnosisScreening',
  'examinationFollowUp'
];
export const CHECKUP_TYPES_WITH_PREPARATIONS = ['threeMonthCheckup', 'yearlyCheckup', 'sixWeekCheckup'];

export const FINAL_NOTE_DIAGNOSIS_CODES = {
  caregiver: [
    {
      value: 'I10.9',
      label: 'Primär hypertoni I10.9'
    },
    {
      value: 'E66.9',
      label: 'Fetma E66.9'
    },
    {
      value: 'E78.5',
      label: 'Hyperlipidemi, ospecificerad E78.5'
    },
    {
      value: 'E11.9',
      label: 'Diabetes mellitus typ 2 utan komplikationer E11.9'
    },
    {
      value: 'I15.9',
      label: 'Sekundär hypertoni, ospecificerad I15.9'
    },
    {
      value: 'Z03.8W',
      label: 'Observation/utredning för misstänkt annan specificerad sjukdom'
    },
    {
      value: 'Z13.9',
      label: 'Riktad hälsokontroll, ospecificerad'
    },
    {
      value: 'E78.0',
      label: 'Isolerad hyperkolesterolemi'
    },
    {
      value: 'E78.2',
      label: 'Blandad hyperlipidemi'
    },
    {
      value: 'I95.1',
      label: 'Ortostatisk hypotoni'
    }
  ],
  nurse: [
    {
      value: 'XS004',
      label: 'Distanskonsultation'
    },
    {
      value: 'DV030',
      label: 'Hälsosamtal'
    },
    {
      value: 'QV005',
      label: 'Information/undervisning om kostfrågor'
    },
    {
      value: 'DV112',
      label: 'Rådgivande samtal om tobaksbruk'
    },
    {
      value: 'QK005',
      label: 'Stresshantering'
    }
  ]
};
export const DIAGNOSED_ICD_CODE = 'I10.9';
export const UNDIAGNOSED_ICD_CODE = 'Z03.5';

export const FINAL_NOTE_STANDARD_ASSESSMENTS = {
  good: 'Bra blodtrycksnivå. Oförändrad medicinering. Livsstilsråd.',
  elevatedNoMedicationChange: 'Förhöjd medelblodtrycksnivå. Livsstilsråd. Oförändrad medicinering.',
  elevatedMedicationChange: 'Förhöjd medelblodtrycksnivå. Livsstilsråd. Medicinjustering.'
};

export const TEMPLATE_TYPE = {
  diagnosisScreening: 'diagnosisScreening',
  referral: 'referral',
  certificate: 'certificate'
};

export const HEART_AUSCULTATION_DURATION = 5;
export const LUNGS_AUSCULTATION_DURATION = 15;
export const LUNGS_AUSCULTATION_DURATION_SHORT = 10;
export const LUNGS_AUSCULTATION_DURATION_CHANGE_DATE = '2022-11-11';
export const HEART_RECORDING_LOCATIONS = ['TopRight', 'TopLeft', 'BottomRight', 'BottomLeft'];
export const LUNG_RECORDING_LOCATIONS = ['TopLeft', 'TopRight', 'MidLeft', 'MidRight', 'BottomLeft', 'BottomRight'];

export const ASSESSMENT_STATUS = {
  CaregiverPaused: 'CaregiverPaused',
  CaregiverRejected: 'CaregiverRejected',
  Completed: 'Completed',
  AwaitingAssessment: 'AwaitingAssessment',
  AssessmentInProgress: 'AssessmentInProgress'
};

export const GUID_REGEX =
  /(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}/;

export const ENCOUNTERS_PER_PAGE = 7;

export const ANSWER_SEPARATOR = '|';

export const WAIT_TIME_URGENCY_THRESHOLD = {
  NURSE: {
    HIGH: 16 * 60,
    LOW: 6 * 60
  },
  DOCTOR: {
    HIGH: 4 * 24 * 60,
    LOW: 2 * 24 * 60
  }
};

export const NOTIFICATION_CHAT_TRIGGERS = [
  'NEW_MESSAGE',
  'APPOINTMENT_FEEDBACK_TIMED_OUT',
  'APPOINTMENT_FEEDBACK_ACKNOWLEDGED',
  'APPOINTMENT_FEEDBACK_QUESTIONED'
];

export const COMPLETED_ASSESSMENT_STATUSES = ['SIGNED', 'REJECTED', 'UNKNOWN', 'VERIFIED_BY_CAREGIVER'];
export const ASSESSMENTS_REQUIRING_TRANSLATIONS = ['SmokingHabits', 'SnuffConsumption', 'SCORE'];

export const NEXT_GEN_ERRANDS_HISTORY_CUTOFF_DAYS = 30;

export const LAB_SAMPLING_MINIMUM_INTERVAL_IN_MONTHS_THRESHOLD = 18;

export const CDSS_TREATMENT_GOALS_ENABLED = true;

export const CDSS_MEDICAL_RECORDS = ['CURRENT_DISEASES', 'PREVIOUS_DISEASES'];

export const SUPPORT_PHONE_NUMBER = '0480-797 960';
